import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { BUILDER } from 'shared/abilities';
import useCurrentPage from 'website/hooks/useCurrentPage';
import { section } from '../decorators';
import stylesGlobal from '../../../theme/facility-globals.scss';
import style from './Reviews.scss';

const Reviews = ({ children, isBuilderView }) => {
  /* eslint-disable id-length */
  const { primaryColorClass,
    secondaryColorBackgroundClass,
    primaryColorBackgroundHoverClass,
    buttonStyleClass } = useCurrentPage();
  /* eslint-enable id-length */
  const [header, button, reviews] = React.Children.toArray(children);
  const btnProps = {
    className: `${secondaryColorBackgroundClass} ${primaryColorBackgroundHoverClass} ${buttonStyleClass}`,
  };

  return (
    <div className={`${stylesGlobal.section} ${style.root}`}>
      <Container>
        <Row>
          <Col md={9} className={primaryColorClass}>
            {header}
          </Col>
          <Col sm={5} md={3} className={`${style.reviewBtnRow} d-none d-sm-block`}>
            {React.cloneElement(button, btnProps)}
          </Col>
        </Row>
        <Row>
          {reviews}
        </Row>
        {!isBuilderView &&
          <Row className={`${style.reviewBtnRow} ${style.mobileRow} d-block d-sm-none`}>
            <Col xs={12}>
              {React.cloneElement(button, { ...btnProps, idPostfix: '2' })}
            </Col>
          </Row>
        }
      </Container>
    </div>
  );
};

Reviews.propTypes = {
  children: PropTypes.node.isRequired,
  isBuilderView: PropTypes.bool.isRequired,
};

const component = section(
  { name: 'Google Reviews', category: 'Reviews' },
  {
    subsections: [
      { accepts: ['HeaderText'] },
      { accepts: ['Button'] },
      { accepts: ['Reviews', 'Accordion'] },
    ],
    defaults: [
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Check Out What Our Customers Are Saying',
              type: 'header-two',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['Button', { text: 'Write a Review', href: null }],
      'Reviews',
    ],
  },
)(Reviews);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
